import { RefObject } from 'react';

export type PopoverAnchorRef = RefObject<HTMLElement | null>;
export type PopoverRef = RefObject<HTMLElement | null>;

export const POPOVER_VERTICAL = {
  TOP: 'top',
  CENTER: 'center',
  BOTTOM: 'bottom',
} as const;

export const POPOVER_HORIZONTAL = {
  LEFT: 'left',
  CENTER: 'center',
  RIGHT: 'right',
} as const;

export interface PopoverOrigin {
  vertical: 'top' | 'center' | 'bottom';
  horizontal: 'left' | 'center' | 'right';
}

export interface PopoverStyle {
  top?: string;
  left?: string;
  'transform-origin'?: string;
}
